import URL from '@/http/user/url'
import AjaxReq from '@/http/ajaxReq'

export default {
  // 校验用户是否存在
  validateUsername: async function(payload) {
    let res = await AjaxReq({
      url: URL.EXECUTE_USER_LOGIN_VALIDATE_USERNAME,
      method: 'get',
      data: {
        userName: payload.userName,
      },
    })
    return res.data
  },
  // 普通用户登录
  userLogin: async function(payload) {
    let res = await AjaxReq({
      url: URL.EXECUTE_USER_LOGIN_VALIDATE_PASSWORD,
      method: 'get',
      data: {
        userName: payload.userName,
        passWord: payload.passWord,
      },
    })
    return res.data
  },
  // 用户--退出登录
  executeUserLogout: async function() {
    let res = await AjaxReq({
      url: URL.EXECUTE_USER_LOGOUT,
      method: 'get',
      data: {},
    })
    return res.data
  },
  /**
   * 校验推广码
   * @param {string} inviteCode 推广码
   */
  checkInviteCode: async function(inviteCode) {
    let res = await AjaxReq({
      url: URL.CHECK_INVITE_CODE,
      method: 'get',
      data: {
        prefix: inviteCode,
      },
    })
    return res.data
  },
  /**
   * 获取推荐人信息
   * @param {string} inviteCode 推广码
   */
  getUperUserInfo: async function(inviteCode) {
    let res = await AjaxReq({
      url: URL.GET_UPER_USER_INFO,
      method: 'get',
      data: {
        prefix: inviteCode,
      },
    })
    return res.data
  },
  /**
   * 发送短信验证码
   * @param {string} mobile 手机号
   * @param {string} needLogin 是否需要登录
   */
  sendSmsCode: async function(mobile, needLogin) {
    let res = await AjaxReq({
      url: URL.SEND_SMS_CODE,
      method: 'get',
      data: {
        mobile: mobile,
        needLogin: needLogin,
      },
    })
    return res.data
  },
  /**
   * 获取用户注册所需的密钥
   */
  loadUserRegisterKey: async function() {
    let res = await AjaxReq({
      url: URL.USER_REGISTER_KEY,
      method: 'get',
      data: {},
    })
    return res.data
  },
  // 用户注册
  userRegister: async function(payload) {
    let res = await AjaxReq({
      url: URL.USER_REGISTER,
      method: 'get',
      data: {
        password: payload.password,
        registerKey: payload.registerKey,
        mobile: payload.mobile,
        smsCode: payload.smsCode,
        photo: payload.photo,
        prefix: payload.prefix,
        code: payload.code,
        unionid: payload.unionid,
        cnName: payload.cnName,
      },
    })
    return res.data
  },
}
